import styled from 'styled-components';
import {
  AppCalculatorResultDownloadButton as DownloadIcon,
  AppCalculatorResultPrintButton as PrintIcon
} from '@elfsight/icons';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { ToolbarButton } from './toolbar-button';
import { useDownloadDocument } from './use-download-document';
import { usePrintDocument } from './use-print-document';

export function ResultsToolbar() {
  const { t } = useLingui();
  const { resultShowPrintButton, resultShowDownloadButton } = useSettings();
  const printDocument = usePrintDocument();
  const downloadDocument = useDownloadDocument();

  if (!resultShowPrintButton && !resultShowDownloadButton) {
    return null;
  }

  return (
    <Container>
      {resultShowPrintButton && (
        <ToolbarButton
          onClick={printDocument}
          aria-label={t`Print`}
          tooltip={t`Print`}
        >
          <PrintIcon />
        </ToolbarButton>
      )}
      {resultShowDownloadButton && (
        <ToolbarButton
          onClick={downloadDocument}
          aria-label={t`Download`}
          tooltip={t`Download`}
        >
          <DownloadIcon />
        </ToolbarButton>
      )}
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 4px;
  z-index: 10;
`;
